<div class="viewers-panel mat-elevation-z4">
	<section
		class="read-receipts-popover"
		role="alert"
		aria-live="polite"
	>
		<div *ngIf="viewersLoading; else viewersLoaded" class="loading-spinner">
			<mat-spinner diameter="24"></mat-spinner>
		</div>
		<ng-template #viewersLoaded>
			<p
				class="comment-viewers-title"
				translate="read-receipts-viewed-by"
			></p>
			<div class="comment-viewers-item" *ngFor="let viewer of viewers">
				<span class="comment-viewers-name">{{ viewer.name }}</span>
				<span class="comment-viewers-date">{{ viewer.viewed_at }}</span>
			</div>
		</ng-template>
	</section>
</div>